import thunk from "redux-thunk";
import { createStore, applyMiddleware, compose } from "redux";
import createRootReducer from "../reducers/rootReducer";
import { createBrowserHistory } from "history";
import { routerMiddleware } from 'connected-react-router'
import userManager from "../Common/Utility/usermanager";
import { loadUser } from "redux-oidc";

export const history = createBrowserHistory({ basename: "/webapp/" });

const storeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const logger = store => next => action => {
    next(action);
}
const store = createStore(createRootReducer(history), storeEnhancers(applyMiddleware(routerMiddleware(history), thunk)));
loadUser(store, userManager);

//store.subscribe(() => console.log("Current Store", store.getState()));

export default store;
